export default {
  langState: state => state.lang,
  langOptionState: state => state.langOption,
  darkModeState: state => state.layoutMode.dark,
  rtlModeState: state => state.layoutMode.rtl,
  loading: state => state.loading,
  appSettings: state => state.appSettings,
};
